import { render, staticRenderFns } from "./ProductLink.vue?vue&type=template&id=4148137b&"
import script from "./ProductLink.ts?vue&type=script&lang=js&"
export * from "./ProductLink.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports